/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import {
  Box,
  FormLabel,
  IconButton,
  InputProps,
  useNumberInput,
} from '@chakra-ui/react';
import { useField } from 'react-final-form';
import { AddIcon, MinusIcon } from 'static/icons';
import { Control, MetaError } from './Control';

export const CountInput: React.FC<
  InputProps & {
    name: string;
    label?: string;
    available?: number;
    mask?: Array<RegExp | string>;
  }
> = ({ className, name, label, available = 1 }) => {
  const { input } = useField(name);

  const { getIncrementButtonProps, getDecrementButtonProps } = useNumberInput({
    name,
    defaultValue: 1,
    min: 1,
    max: available,
    step: 1,
    pattern: '[0-9]*',
    onChange: (_, valueAsNumber: number) => input.onChange(valueAsNumber),
    value: input.value,
  });
  const inc = getIncrementButtonProps();
  const dec = getDecrementButtonProps();

  useEffect(() => {
    if (!input.value) {
      input.onChange(1);
    }
  }, [input]);

  return (
    <Control name={name} className={className} width="auto">
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gridGap="10px"
        fontSize="0.875rem"
      >
        <IconButton
          {...dec}
          size="xs"
          aria-label="Decrement service count"
          icon={<MinusIcon width={10} height={10} />}
        />
        {input.value}
        <IconButton
          {...inc}
          size="xs"
          aria-label="Increment service count"
          icon={<AddIcon width={10} height={10} />}
        />
      </Box>
      <MetaError name={name} />
    </Control>
  );
};
